import type { FC, PropsWithChildren } from 'react';
import Link from 'next/link';
import { Button as ChakraButton, type ButtonProps as ChakraButtonProps } from '@chakra-ui/react';
const ContainerComponent: FC<Omit<ButtonProps, 'href' | 'target'>> = ({
  children,
  ariaLabel,
  disabled = false,
  type = 'button',
  onClick,
  ...props
}) => <ChakraButton variant="ghost" aria-label={ariaLabel} type={type} onClick={onClick} isDisabled={disabled} justifyContent="center" alignItems="center" gap="2.5" w="full" h="full" fontSize="lg" fontWeight="medium" color="var(--color-eqi-white)" {...props} data-sentry-element="ChakraButton" data-sentry-component="ContainerComponent" data-sentry-source-file="index.tsx">
    {children}
  </ChakraButton>;
const WithLink: FC<ButtonProps> = ({
  href,
  target = '_self',
  ...props
}) => <Link href={href!} target={target} passHref prefetch data-sentry-element="Link" data-sentry-component="WithLink" data-sentry-source-file="index.tsx">
    <ContainerComponent {...props} data-sentry-element="ContainerComponent" data-sentry-source-file="index.tsx" />
  </Link>;
export const Button: FC<ButtonProps> = ({
  href,
  ...props
}) => href ? <WithLink href={href} {...props} /> : <ContainerComponent {...props} />;
export type ButtonProps = PropsWithChildren<Omit<ChakraButtonProps, 'aria-label' | 'isDisabled'> & {
  ariaLabel?: string;
  href?: string;
  target?: string;
}>;